module.exports = __webpack_public_path__ + "static/media/nababrata-deb.c9508755.jpeg";